import * as React from 'react';

export const UpgradeToPremium = () => {
  const handleClick = () => {
    Object.keys(window.Avochato.widgets).forEach((key) => {
      window.Avochato.widgets[key].openWithOption('current customer');
    });
  };
  return (
    <div className="upgrade-to-premium body pa-20">
      <p className="dark-green bold-900">Upgrade to Premium</p>
      <button
        type="button"
        className="button md bright-green mt-15"
        onClick={handleClick}
        onKeyPress={handleClick}
      >
        Contact Us
      </button>
    </div>
  );
};
